import {
  CrystalDTO,
  DewarDTO,
  IPFDocProteinFormulationDTO,
  PuckDTO,
  SynchTripDTO,
} from 'business/models/Models';

export enum SynchrotronTripTab {
  Info = 1,
  CrystalResults = 2,
  UnassignedCrystals = 3,
}

export type EditStatus = {
  isDirty?: boolean;
  isSaving?: boolean;
};
export type FetchStatus = {
  isLoading: boolean;
  refetch: boolean;
};

export type CrystalContainerAssignments = {
  puckPinPosition?: number;
  puckId?: number;
  dewarId?: number;
  isDirty?: boolean;
  isUpdated?: boolean;
};

export interface CrystalDataDTO
  extends Omit<
    CrystalDTO,
    | 'toJSON'
    | 'init'
    | 'assignedPinPosition'
    | 'assignedPuckId'
    | 'assignedDewarId'
    | 'proteinFormulationDTO'
  > {
  crystalContainerAssignments: CrystalContainerAssignments;
  proteinFormulationDTO: IPFDocProteinFormulationDTO;
}

export type SynchTripReportOptionsProps = {
  tripInfoReport: boolean;
  tripResultReport: boolean;
};

export interface SynchTripDataDTO
  extends Omit<SynchTripDTO, 'toJSON' | 'init' | 'assignedCrystals'> {
  assignedCrystals: CrystalDataDTO[];
  isCrystalAssignmentsDirty: boolean;
  editStatus: EditStatus;
}

export type PuckDataDTO = Omit<PuckDTO, 'toJSON' | 'init'>;

export type DewarDataDTO = Omit<DewarDTO, 'toJSON' | 'init'>;

export enum SynchrotronTripResultStatus {
  NoResult = 0,
  Partial = 1,
  Complete = 2,
}

export const SynchrotronTripResultLookup: { [key: string]: string } = {
  [SynchrotronTripResultStatus.NoResult]: 'No Result',
  [SynchrotronTripResultStatus.Partial]: 'Partial',
  [SynchrotronTripResultStatus.Complete]: 'Complete',
};

export const ImportTripResultColumns = [
  {
    accessor: 'crystalId',
    Header: 'Crystal Id',
    className: 'importResult70',
  },
  {
    accessor: 'crystalName',
    Header: 'Crystal Name',
    className: 'importResult130',
  },
  {
    accessor: 'puckBarcode',
    Header: 'Puck Bar Code',
    className: 'importResult70',
  },
  {
    accessor: 'puckPinPostion',
    Header: 'Puck Pin Position',
    className: 'importResult70',
  },
  {
    accessor: 'synchTripId',
    Header: 'Trip Id',
    className: 'importResult70',
  },
  {
    accessor: 'synchTripName',
    Header: 'Trip Name',
    className: 'importResult70',
  },
  {
    accessor: 'dateFrozen',
    Header: 'Date Frozen',
    className: 'importResult130',
  },
  {
    accessor: 'crystalNameInternal',
    Header: 'Crystal Name (Internal)',
    className: 'importResult130',
  },
  {
    accessor: 'symm',
    Header: 'Space Group',
    className: 'importResult70',
  },
  {
    accessor: 'xtalRun',
    Header: 'xtal_run',
    className: 'importResult70',
  },
  {
    accessor: 'resoLow',
    Header: 'Res_lo',
    className: 'importResult70',
  },
  {
    accessor: 'hiShells',
    Header: 'Res_hi',
    className: 'importResult70',
  },
  {
    accessor: 'cellA',
    Header: 'a',
    className: 'importResult50',
  },
  {
    accessor: 'cellB',
    Header: 'b',
    className: 'importResult50',
  },
  {
    accessor: 'cellC',
    Header: 'c',
    className: 'importResult50',
  },
  {
    accessor: 'cellAlpha',
    Header: 'α',
    className: 'importResult50',
  },
  {
    accessor: 'cellBeta',
    Header: 'β',
    className: 'importResult50',
  },
  {
    accessor: 'cellGamma',
    Header: 'γ',
    className: 'importResult50',
  },
  {
    accessor: 'raddamRFree',
    Header: 'R, R-free',
    className: 'importResult70',
  },
  {
    accessor: 'e21',
    Header: 'E^2-1',
    className: 'importResult50',
  },
  {
    accessor: 'compEll',
    Header: '%comp_ell',
    className: 'importResult70',
  },
  {
    accessor: 'compSph',
    Header: '%comp_sph',
    className: 'importResult70',
  },
  {
    accessor: 'rMeas',
    Header: '%Rmeas',
    className: 'importResult70',
  },
  {
    accessor: 'foFC',
    Header: 'Fo-Fc',
    className: 'importResult70',
  },
  {
    accessor: 'multiplicity',
    Header: 'Multiplicity',
    className: 'importResult70',
  },
  {
    accessor: 'cc12',
    Header: 'CC1/2',
    className: 'importResult70',
  },
  {
    accessor: 'iSigma',
    Header: 'LSigmaI',
    className: 'importResult70',
  },
  {
    accessor: 'refinementProgram',
    Header: 'Refinement Program',
    className: 'importResult70',
  },
  {
    accessor: 'resultNotes',
    Header: 'Result Notes',
    className: 'importResult130',
  },
  {
    accessor: 'resultStatus',
    Header: 'Result Status',
    className: 'importResult70',
  },
];

export enum SynchTripStatus {
  Open = 'Open',
  Close = 'Close',
}
